// extracted by mini-css-extract-plugin
module.exports = {"theme":"#ff6844"};